import { useState } from 'react';
import { api } from './api';
import { text, type Locale } from '../shared/content';
import { errorText } from './i18n';
const copy = {
  title: text('Account reviews', '账号复核', '帳號複核', 'Revisiones de cuentas'),
  pending: text('Open appeals', '待处理申诉', '待處理申訴', 'Apelaciones pendientes'),
  lift: text('Lift restriction', '解除限制', '解除限制', 'Retirar restricción'),
  uphold: text('Maintain restriction', '维持限制', '維持限制', 'Mantener restricción'),
  note: text(
    'Decision explanation · 5–500 characters',
    '复核说明 · 5–500 字',
    '複核說明 · 5–500 字',
    'Explicación · 5–500 caracteres',
  ),
  lookup: text(
    'Find a resident by name or character ID',
    '按姓名或角色 ID 查找',
    '依姓名或角色 ID 尋找',
    'Buscar por nombre o ID de personaje',
  ),
  search: text('Search', '查找', '尋找', 'Buscar'),
  clear: text('Clear current restriction', '解除当前限制', '解除目前限制', 'Retirar la restricción actual'),
  empty: text('No open appeals.', '暂无待处理申诉。', '暫無待處理申訴。', 'No hay apelaciones pendientes.'),
  restricted: text('Restricted', '受限', '受限', 'Restringido'),
  active: text('No active restriction', '无有效限制', '無有效限制', 'Sin restricciones activas'),
};
export default function AdminAccounts({
  locale,
  appeals,
  busy,
  onAction,
  onMessage,
}: {
  locale: Locale;
  appeals: any[];
  busy: boolean;
  onAction: (type: string, payload: Record<string, unknown>) => Promise<void>;
  onMessage: (s: string, error?: boolean) => void;
}) {
  const t = (k: keyof typeof copy) => copy[k][locale];
  const [notes, setNotes] = useState<Record<string, string>>({}),
    [query, setQuery] = useState(''),
    [residents, setResidents] = useState<any[]>([]);
  return (
    <section>
      <h3>{t('pending')}</h3>
      {appeals.length ? (
        appeals.map((a) => (
          <article className="admin-report" key={a.id}>
            <strong>{a.name || a.character_id}</strong>
            <p>{a.body}</p>
            <label>
              {t('note')}
              <textarea
                aria-label={`${t('note')} ${a.name}`}
                minLength={5}
                maxLength={500}
                value={notes[a.id] || ''}
                onChange={(e) => setNotes({ ...notes, [a.id]: e.target.value })}
              />
            </label>
            <div className="vote-buttons">
              {(['lift', 'uphold'] as const).map((decision) => (
                <button
                  key={decision}
                  className="button soft compact"
                  disabled={busy || (notes[a.id] || '').trim().length < 5}
                  onClick={() => onAction('appeal.review', { appealId: a.id, decision, note: notes[a.id] })}
                >
                  {t(decision)}
                </button>
              ))}
            </div>
          </article>
        ))
      ) : (
        <p className="muted small">{t('empty')}</p>
      )}
      <h3>{t('title')}</h3>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            setResidents((await api(`/admin/lookup?query=${encodeURIComponent(query)}`)).residents);
          } catch (error) {
            onMessage(errorText(locale, error), true);
          }
        }}
      >
        <label>
          {t('lookup')}
          <input
            required
            minLength={3}
            maxLength={80}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </label>
        <button className="button soft full" disabled={busy || query.trim().length < 3}>
          {t('search')}
        </button>
      </form>
      {residents.map((r) => (
        <article className="admin-report" key={r.id}>
          <strong>{r.name}</strong>
          <small>{r.id}</small>
          <p>{r.restriction_reason || t('active')}</p>
          {r.restriction_reason && (
            <button
              className="button light full"
              disabled={busy}
              onClick={async () => {
                await onAction('unrestrict', { characterId: r.id });
                setResidents((await api(`/admin/lookup?query=${encodeURIComponent(query)}`)).residents);
              }}
            >
              {t('clear')}
            </button>
          )}
        </article>
      ))}
    </section>
  );
}
